import { Component, Input, OnInit } from '@angular/core';
import { AlertService } from '../../services/alert.service';
@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {
  @Input() text = '';
  get isSaving(): boolean {
    return this.alertService.isLoadingInProgress;
  }
  constructor(
    private alertService: AlertService
  ) { }

  ngOnInit(): void {
  }

}
